import { Link } from "react-router-dom";
import { MessageCircle, Mail, Phone, MapPin } from "lucide-react";
import { SITE, waLink } from "../data/site";
import { SOLUTIONS } from "../data/solutions";

export const Footer = () => (
  <footer className="border-t border-seam bg-iron" data-testid="main-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4 lg:px-16">
      <div>
        <div className="flex items-center gap-3">
          <span className="inline-block rounded-sm border border-seam bg-white px-3 py-1.5 shadow-sm">
            <img src="/images/logo.png" alt="SABAKT — سبكت للأعمال المعدنية" className="h-9 w-auto" />
          </span>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-cadmium">
          Industrial engineering, fabrication, wear protection and equipment reconditioning for demanding operations across the Kingdom of Saudi Arabia.
        </p>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-widest text-cadmium/70">
          Send us the problem. We'll engineer the solution.
        </p>
      </div>
      <div>
        <h4 className="font-brand text-sm font-bold uppercase tracking-widest text-gold">Solutions</h4>
        <ul className="mt-4 space-y-2">
          {SOLUTIONS.slice(0, 6).map((s) => (
            <li key={s.slug}>
              <Link to={`/solutions/${s.slug}`} className="text-sm text-cadmium transition-colors hover:text-spark">{s.title}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-brand text-sm font-bold uppercase tracking-widest text-gold">Company</h4>
        <ul className="mt-4 space-y-2">
          {[["About SABAKT", "/about"], ["Industries We Serve", "/industries"], ["Products", "/products"], ["Projects", "/projects"], ["Insights", "/insights"], ["Contact", "/contact"], ["Request a Quote", "/rfq"]].map(([label, to]) => (
            <li key={to}>
              <Link to={to} className="text-sm text-cadmium transition-colors hover:text-spark">{label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-brand text-sm font-bold uppercase tracking-widest text-gold">Contact</h4>
        <ul className="mt-4 space-y-3 text-sm text-cadmium">
          <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0 text-spark" /> {SITE.city}</li>
          <li className="flex items-center gap-2"><Phone size={16} className="shrink-0 text-spark" /> {SITE.phone}</li>
          <li className="flex items-center gap-2"><Mail size={16} className="shrink-0 text-spark" /> {SITE.email}</li>
          <li>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 border border-seam px-4 py-2 text-sm font-semibold text-frost transition-colors hover:border-spark hover:text-spark">
              <MessageCircle size={16} /> WhatsApp SABAKT
            </a>
          </li>
        </ul>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-cadmium/50">{SITE.hours}</p>
      </div>
    </div>
    <div className="border-t border-seam py-5 text-center font-mono text-[11px] uppercase tracking-widest text-cadmium/60">
      © {new Date().getFullYear()} SABAKT · Riyadh, Kingdom of Saudi Arabia
    </div>
  </footer>
);
